import { Component, EventEmitter, Input, Output, Type } from "@angular/core";
import { TranslationService } from "@app/services/translation.service";

@Component({
    selector: 'v-select-input',
    template: require('./v-select-input.component.html')
})
export class VSelectInputComponent {
    @Input() value: string;
    @Input() label: string;
    @Input() options: string[];
    @Input() otherText: string = this.translationService.t("Common.Other_");

    @Output() valueChange = new EventEmitter<any>();

    //--

    showInputField: boolean;

    constructor(
        private readonly translationService: TranslationService) { }

    onSelectedValueChanged(value): void {
        this.showInputField = value == 'other';

        if (this.showInputField) {
            return;
        }

        this.valueChange.emit(value);
    }

    onInputChanged(value: string): void {
        this.valueChange.emit(value);
    }
}
